<template>
  <v-btn color="primary" :to="{ name: 'add-self-return-shipment', params: { orderId: id }, }"> Новая накладная</v-btn>
</template>

<script>
export default {
  name: "OpenCreateReturnShipment",
  props: {
    id: {
      type: Number,
      default: 0
    }
  }
}
</script>

<style scoped>

</style>